<template>
    <div class="left-side-bar">
        <!-- Sidebar filter placeholders -->
    </div>
</template>

<script>
export default {
    name: 'LeftSideBar'
}
</script>

<style scoped>
.left-side-bar {
    display: none;
}
</style>



// WEBPACK FOOTER //
// resources/js/course_new/LeftSideBar.vue